import { featureFlagConstants } from "../constants/FeatureFlagConstants"

const initialState = {
  featureFlags: {},
  isFetched: false
}

export const features = (state = initialState, action) => {
  switch (action.type) {
    case featureFlagConstants.GET_FEATURE_FLAG:
      return {
        ...state,
        featureFlags: {
          ...state.featureFlags,
          ...action.featureFlags
        }
      }

    default:
      return state
  }
}
